<template>
  <svg role="img" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" aria-label="A filled-in circle">
    <circle cx="6" cy="6" r="5.5" stroke="currentColor" />
  </svg>
</template>
